<div class="container">
    <h1 class="principal-title">{{tier1.shorttitle}}</h1>
    <br>
    <div class="row">
        <div id="mapa" class="col-12 col-sm-12 col-md-8 col-lg-8"> </div>
        <div class="col-12 col-sm-12 col-md-4 col-lg-4 parrafo">
            <div id="detalle" style="display:none;">
                <div id="nodo_selec" class="col-12">Nodo seleccionado</div>
                <div class="detalle-sumilla">
                    <div id="titulo_nodo" class="parrafo_detalle"></div>
                    <div id="resumen_nodo"></div>
                    <br>
                    <div id="relacionados"></div>
                </div>
            </div>
            <div id="descripcion" style="padding-bottom: 10px;">
                <div class="col-12 subtitulo2">
                    <strong> {{tier1.summary}}</strong>
                </div>
                <ul class="col-12 parrafo" style="list-style-position: inside;" [innerHTML]="tier1.detail">
                </ul>
            </div>
            <p></p>
        </div>
    </div>
    <div class="col-12 parrafo">
        Nota. El tamaño de las figuras indica el grado de asociación de cada megatendencia y tendencia, de manera que
        una figura con mayor tamaño representa un elemento muy relacionado al resto. Imagen adaptada del World Economic
        Forum, con información del Observatorio Nacional de Prospectiva.
    </div>
</div>